import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';

// src/helpers/factories/locationGroupsFactory.ts
var locationGroupToLocationFactory = (locationsGroups) => Object.values(locationsGroups).map((locGrp) => ({
  locationGroupId: locGrp.id,
  name: locGrp.name,
  locations: locGrp.locations.reduce(
    (acc, loc) => __spreadProps(__spreadValues({}, acc), {
      [loc.id]: {
        locationId: loc.id,
        name: loc.name,
        description: `${loc.streetLine1}
${loc.city}, ${loc.state}`
      }
    }),
    {}
  )
})).reduce(
  (acc, locGrp) => __spreadProps(__spreadValues({}, acc), { [locGrp.locationGroupId]: locGrp }),
  {}
);
var locationsListFactory = (locationsGroups) => {
  return Object.values(locationsGroups).map((locationGroup) => locationGroup.locations).flat();
};

export { locationGroupToLocationFactory, locationsListFactory };
